import React, {useState, useEffect} from 'react';
import { AgGridReact } from "ag-grid-react";
import { SBAComboBox } from '../../../UiComponents/SBADropDown';
import { SBADrawer } from '../../../UiComponents/SBADrawer';
import moment from "moment";
import { SBDatePicker } from '../../../UiComponents/SBDatePicker';

const PartnershipDetailStep = ({}) => {
    const [showDrawer, setShowDrawer] = useState(false);
    const [partnershipList, setPartnershipList] = useState([]);
    const [selectedPartnership, setSelectedPartnership] = useState(null);
    const [partnersList, setPartnersList] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [aoDate, setAoDate] = useState(new Date());
    const [partnerPercent, setPartnerPercent] = useState(null);
    const [gridData, setGridData] = useState([]);
    const colDefs = [
        {headerName:'Partnership Name', field:'partnershipName'},
        {headerName:'Partner Name', field:'partnertName'},
        {headerName:'Partner Short Name', field:'partnershortName'},
        {headerName:'Account Name', field:'accountName'},
        {headerName:'Client Statement Name', field:'clientStatementName'},
        {headerName:'Date', field:'startDate'},
        {headerName:'Action', field:'action',}
    ]
    return(
        <>
        <div className='container-fluid' style={{paddingTop:0, marginTop:'20px'}}>
            <div className="h4">Add/Update Partnership</div>
            <div className='row'>
                <div>
                    <label className="label">Partners</label>
                    <div>
                        <SBAComboBox
                            data={partnersList}
                            textField={"partnershipName"}
                            valueField={"partnershipId"}
                            value={selectedPartner}
                            onChange={(e)=>setSelectedPartner(e.value)}
                            popupSettings={{ className: "modalDD" }}
                            style={{width:"250px"}}
                        ></SBAComboBox>
                    </div>
                </div>
            </div>
            <div className='row d-flex justify-content-end' style={{ marginRight:'65px' }}>
            <button
                type="submit"
                className="p-sm-btn"
                onClick={() => setShowDrawer(true)}
                style={{width:'75px'}}
            >
            Add
            </button>
            </div>
            <div className='row w-100'>
            <div
                className="row my-4"
                style={{ height: "500px", width: "100%" }}
            >
              <div className="row col-12 h-100">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100%", width: "100%", paddingTop: 0 }}
                >
                  <AgGridReact
                    rowData={gridData}
                    columnDefs={colDefs}
                    defaultColDef={{ flex: 1, resizable: true, minWidth: 100 }}
                  />
                </div>
              </div>
            </div>
            </div>
        </div>
        <SBADrawer
          open={showDrawer}
          setOpen={setShowDrawer}
          close={false}
          title={"Add Partner Percentage"}
        >
          <div className="row mb-4">
            <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Partnership</label>
                <SBAComboBox
                    data={partnershipList}
                    textField={"partnershipName"}
                    valueField={"partnershipId"}
                    value={selectedPartnership}
                    onChange={(e)=>setSelectedPartnership(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
            <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Partner</label>
                <SBAComboBox
                    data={partnersList}
                    textField={"partnershipName"}
                    valueField={"partnershipId"}
                    value={selectedPartner}
                    onChange={(e)=>setSelectedPartner(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">As of Date</label>
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  {" "}
                  {/* Added flexbox for input and button */}
                  <SBDatePicker
                    value={moment(aoDate)}
                    onChange={(newDate) => setAoDate(newDate)}
                    style={{width:"250px"}}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
            <div>
                <label className="label">Partner Percentage</label>
                <input
                    type="number"
                    className="input-default form-control text-right no-arrows"
                    value={partnerPercent}
                    onChange={(e)=>setPartnerPercent(e.target.value)}
                    style={{width:"250px"}}
                />
              </div>
            </div>
          </div>
          <div className="m-1 d-flex justify-content-end mt-2">
            <button className="s-sm-btn mx-1" onClick={()=>setShowDrawer(false)}>Cancel</button>
            <button className="p-sm-btn mx-1" onClick={()=>console.log('Adding new partnership')}>Add</button>
          </div>
        </SBADrawer> 
        </>               
    );
};

export default PartnershipDetailStep;